import React from 'react';
import { Input, Select, Icon, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idTipoPersona ? { key: this.props.filter.idTipoPersona } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Tipo Persona" />}
                            onChange={(option) => this.props.onChange("idTipoPersona", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.tiposPersona.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idTipoDocumento ? { key: this.props.filter.idTipoDocumento } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Tipo Documento" />}
                            onChange={(option) => this.props.onChange("idTipoDocumento", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.tiposDocumento.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.abreviatura}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.numeroDocumento}
                            onChange={e => this.props.onChange("numeroDocumento", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por Número Documento"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.NombreRazonSocial}
                            onChange={e => this.props.onChange("NombreRazonSocial", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por Nombre / Razón Social"
                            autoComplete="off"
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;